const images = import.meta.glob('../img/**/*.{ico,png,jpg,jpeg,svg,webp}', { eager: true });

export default images;
